export default __webpack_public_path__ + "static/media/myPatient_labResults_x.6b9f9919.jpg";